// ClasseContext.js
import { createContext, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { url } from '../utils/confserveur';
const ClasseContext = createContext();

export const useClasseContext = () => useContext(ClasseContext);

export const ClasseProvider = ({ children }) => {
    const [classeNom, setClasseNom] = useState('');
    const [groupNom, setGroupNom] = useState('');
    const [classeDetail, setClasseDetail] = useState({})
    const [etablissement, setEtablissement] = useState('');
    const [nomProf, setNomProf] = useState('');
    const [classesGroup, setClassesGroup] = useState([]);
    const [nomChef, setNomChef] = useState('')

    const [niveauEvalnat, setNiveauEvalnat] = useState('')
    const [ActivePeriode, setActivePeriode] = useState('');
// États de chargement et d'erreur
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fonction de déconnexion qui réinitialise le contexte
  const logout = () => {
   setClasseNom('')
   setEtablissement('')
   setNomProf('')
   setClassesGroup('')
   setNomChef('')
   setIsLoading(false)
   setError(null)
   setNiveauEvalnat('')
   setClasseDetail('')
   setGroupNom('')
   setActivePeriode('')
   localStorage.clear();
  };
  const fetchClasseData = async (item) => {
    if (classeNom) {
      setIsLoading(true);
            setError(null);
      try {
    
        const response = await axios.get(`${url}classes/${item}/`, {
          withCredentials: true,
        });
        setClasseDetail(response.data); // Stocker les données des établissements

      } catch (error) {
        setError(error.message)
        console.error("Erreur lors de la récupération des données de la classe :", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

    const value = {
        classeNom,
        setClasseNom,
        classeDetail,
        setClasseDetail,
        isLoading,
        error,
        etablissement,
        setEtablissement,
        nomProf,
        groupNom,
        classesGroup,
        nomChef,
        setNomChef,
        setClassesGroup,
        setGroupNom,
        setNomProf,
        niveauEvalnat,
        setNiveauEvalnat,
        fetchClasseData,
        ActivePeriode,
        setActivePeriode,
        logout
     // Exposez cette fonction aux composants enfants
    };
    return <ClasseContext.Provider value={value}>{children}</ClasseContext.Provider>;
};